export default {
  routes: {
    /**
         * Sub sections which are placed under parent sections
         */
    Users: {
      name: 'Users',
      permissions: ['admin-view-identity-users'],
      url: '/identities/users',
      icon: 'icon-people',
      parent: 'Identities'
    },
    Permissions: {
      name: 'Permissions',
      permissions: ['admin-view-identity-permissions'],
      url: '/identities/permissions',
      icon: 'icon-user-following',
      parent: 'Identities'
    },
    Roles: {
      name: 'Roles',
      permissions: ['admin-view-identity-roles'],
      url: '/identities/roles',
      icon: 'icon-briefcase',
      parent: 'Identities'
    },
    TvCodes: {
      name: 'TvCodes',
      permissions: ['admin-view-identity-users'],
      url: '/identities/tvcodes',
      icon: 'icon-people',
      parent: 'Identities'
    },
    Clients: {
      name: 'Clients',
      permissions: ['clients-view'],
      url: '/documents/clients',
      icon: 'icon-notebook',
      parent: 'Documents'
    },
    // Contract: {
    //     name: 'Contract',
    //     permissions: ['contracts-view'],
    //     url: '/documents/contract',
    //     icon: 'icon-notebook',
    //     parent: 'Documents'
    // },
    Contracts: {
      name: 'Contracts',
      permissions: ['contracts-view'],
      url: '/documents/contracts',
      icon: 'icon-notebook',
      parent: 'Documents'
    },
    Templates: {
      name: 'Templates',
      permissions: ['templates-view'],
      url: '/documents/templates',
      icon: 'icon-notebook',
      parent: 'Documents'
    },
    Worklogs: {
      name: 'Worklogs',
      permissions: ['worklogs-view'],
      url: '/jira/worklogs',
      icon: 'icon-notebook',
      parent: 'Jira'
    },
    WorklogsPersons: {
      name: 'Worklogs Persons',
      permissions: ['worklogs-view'],
      url: '/jira/worklogs-persons',
      icon: 'icon-notebook',
      parent: 'Jira'
    },
    ProjectWorklogs: {
      name: 'Project Worklogs',
      permissions: ['project-worklogs-view'],
      url: '/jira/project-worklogs',
      icon: 'icon-notebook',
      parent: 'Jira'
    },
    ProjectsOverview: {
      name: 'Projects overview',
      permissions: ['project-finances-view'],
      url: '/jira/projects-overview',
      icon: 'icon-notebook',
      parent: 'Jira',
    },
    // ProjectGraphics: {
    //     name: 'Project Graphics',
    //     permissions: ['project-graphics-view'],
    //     url: '/jira/project-graphics',
    //     icon: 'icon-graph',
    //     parent: 'Jira'
    // },
    // CreateUserRate: {
    //     name: 'New user rate',
    //     permissions: ['new-user-rate-view'],
    //     url: '/jira/new-user-rate',
    //     icon: 'icon-notebook',
    //     parent: 'Jira',
    // },
    IncomingPayments: {
      name: 'Contractual Payments',
      permissions: ['incoming-payments-view'],
      url: '/documents/incoming-payments',
      icon: 'icon-notebook',
      parent: 'Documents',
    },
    // Employees: {
    //   name: 'Employees',
    //   permissions: ['employees-view'],
    //   url: '/jira/employees',
    //   icon: 'icon-notebook',
    //   parent: 'Jira',
    // },
    EmployeesNew: {
      name: 'EmployeesNew',
      permissions: ['employees-view'],
      url: '/employees',
      icon: 'icon-people',
      parent: 'Jira',
    },
    AuditLogs: {
      name: 'Audit Logs',
      permissions: ['audit-logs-view'],
      url: '/jira/audit-logs',
      icon: 'icon-notebook',
      parent: 'Jira',
    },
    // Projects: {
    //     name: 'Projects',
    //     permissions: ['project-worklogs-view'],
    //     url: '/jira/projects',
    //     icon: 'icon-notebook',
    //     parent: 'Jira',
    // },
    // ProjectFinancesOld: {
    //     name: 'Project Finances',
    //     permissions: ['project-finances-view'],
    //     url: '/jira/project-finances-old',
    //     icon: 'icon-notebook',
    //     parent: 'Jira',
    // },
    // ProjectFinances: {
    //     name: 'Project Finances v2',
    //     permissions: ['project-finances-view'],
    //     url: '/jira/project-finances',
    //     icon: 'icon-notebook',
    //     parent: 'Jira',
    // },
    Invoices: {
      name: 'Invoices',
      permissions: ['invoices-view'],
      url: '/documents/invoices',
      icon: 'icon-notebook',
      parent: 'Documents',
    },
    CashFlowPlan: {
      name: 'Cash-flow & Revenue report',
      permissions: ['invoices-view'],
      url: '/documents/cash-flow-plan',
      icon: 'icon-notebook',
      parent: 'Documents',
    },
    SpecialBusinessDays: {
      name: 'Special business days',
      permissions: ['edit-special-business-days'],
      url: '/jira/special-days',
      icon: 'icon-calendar',
      parent: 'Jira',
    },
    ProjectIssues: {
      name: 'Project Issues',
      permissions: ['project-issues-view'],
      url: '/jira/jira-projects',
      icon: 'icon-calendar',
      parent: 'Jira',
    },

    Dash: {
      name: 'Dash main',
      permissions: [],
      url: '/dash/main',
      icon: 'icon-calendar',
      parent: 'Dash',
    },
    Dash2024: {
      name: 'Dash main 2024',
      permissions: [],
      url: '/dash/main2024',
      icon: 'icon-calendar',
      parent: 'Dash',
    },
    AllProjectGant: {
      name: 'All Project Gant',
      permissions: ['project-graphics-view'],
      url: '/dash/allprojectgant',
      icon: 'icon-chart',
      parent: 'Dash',
    },
    AllProjectWorklogs: {
      name: 'All Project Worklogs',
      permissions: ['project-graphics-view'],
      url: '/dash/allprojectworklogs',
      icon: 'icon-chart',
      parent: 'Dash',
    },
    Billable: {
      name: 'Billable',
      permissions: ['project-graphics-view'],
      url: '/dash/billable',
      icon: 'icon-chart',
      parent: 'Dash',
    },
    BillableTable: {
      name: 'BillableTable',
      permissions: ['project-graphics-view'],
      url: '/dash/billable-table',
      icon: 'icon-chart',
      parent: 'Dash',
    },
    UserIssues: {
      name: 'UserIssues',
      permissions: ['project-graphics-view'],
      url: '/reports/UserIssues',
      icon: 'icon-chart',
      parent: 'Dash',
    },
    RecentWorklogsHeat: {
      name: 'RecentWorklogsHeat',
      permissions: ['project-graphics-view'],
      url: '/dash/RecentWorklogsHeat',
      icon: 'icon-chart',
      parent: 'Dash',
    },
    ProjectIssueForTimeStats: {
      name: 'Project Issue Stats',
      permissions: [],
      url: '/dash/ProjectIssueForTimeStats',
      icon: 'icon-chart',
      parent: 'Dash',
    },
    Absences: {
      name: 'Absences',
      permissions: [],
      url: '/dash/absences',
      icon: 'icon-chart',
      parent: 'Dash',
    },
    Idle: {
      name: 'Idle',
      permissions: [],
      url: '/dash/idle',
      icon: 'icon-chart',
      parent: 'Dash',
    },
    WorkLogStats: {
      name: 'WorkLogStats',
      permissions: [],
      url: '/dash/WorkLogStats',
      icon: 'icon-chart',
      parent: 'Dash',
    },
    VacationsTypeslist: {
      name: 'Types list',
      permissions: ['admin-dashboard'],
      url: '/vacations/types',
      icon: 'icon-docs',
      parent: 'Vacations',
    },
    VacationsList: {
      name: 'Vacations list',
      permissions: [],
      url: '/vacations/list',
      icon: 'icon-docs',
      parent: 'Vacations',
    },

    // EnvEditor: {
    //     name: '.env-Editor',
    //     permissions: ['edit-env'],
    //     url: '/jira/enveditor',
    //     icon: 'icon-notebook',
    //     parent: 'Jira',
    // },
    // VacationPlanner: {
    //     name: 'Vacation planner',
    //     permissions: ['planned-vacations-view'],
    //     url: '/jira/planned-vacations',
    //     icon: 'icon-notebook',
    //     parent: 'Jira',
    // }
  },
  /**
     * Large sections which contain sub sections
     */
  sections: {
    Identities: {
      name: 'Identities',
      icon: 'icon-lock'
    },
    Documents: {
      name: 'Documents',
      icon: 'icon-docs'
    },
    Jira: {
      name: 'Jira',
      icon: 'icon-docs'
    },
    Dash: {
      name: 'Dash',
      icon: 'icon-chart'
    },
    Vacations: {
      name: 'Vacations',
      icon: 'icon-user'
    },
  }
};
